import { useEffect, useState } from 'react';
import { getEssentialInformationData } from '../api/Services';

export function useInformationData() {
  const [information, setInformation] = useState({});
  const [loading, setLoading] = useState({});

  async function callGetInfoEssential() {
    setLoading(true);
    try {
      const { data } = await getEssentialInformationData();
      const dataResult = data.result[0];
      document.title = `Farscada - ${dataResult.plantName}`;
      localStorage.setItem('plantName', dataResult.plantName);
      setInformation({
        ID: dataResult.ID,
        image: dataResult.image,
        logo: dataResult.logo,
        ownerName: dataResult.ownerName,
        plantName: dataResult.plantName,
      });
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    callGetInfoEssential();
  }, []);

  return {
    information,
    loading,
  };
}
